/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Models_DescriptionInputs */

const en_directory_tools_models_description = /** @type {(inputs: Directory_Tools_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse and compare AI models side by side.`)
};

const zh_directory_tools_models_description = /** @type {(inputs: Directory_Tools_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览并对比各类 AI 模型。`)
};

/**
* | output |
* | --- |
* | "Browse and compare AI models side by side." |
*
* @param {Directory_Tools_Models_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_models_description = /** @type {((inputs?: Directory_Tools_Models_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Models_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_models_description(inputs)
	return zh_directory_tools_models_description(inputs)
});
export { directory_tools_models_description as "directory.tools.models.description" }